import reducer from './reducer';

export const { openPayingModal, closePayingModal, setPaymentStatus } = reducer.actions;
